const forecastQueryKeys = {
  all: [{ scope: 'forecast' }] as const,
  lists: () => [{ ...forecastQueryKeys.all[0], entity: 'list' }] as const,
  list: (companyId: string) => [{ ...forecastQueryKeys.lists()[0], companyId }] as const,
  detail: (companyId: string, scenarioId: string) =>
    [{ ...forecastQueryKeys.all[0], entity: 'detail', companyId, scenarioId }] as const
}

export default forecastQueryKeys
